 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"agentManagement~case-add~case-edit~caseDetail~client~clientDetail~dashboard~documentManagement~ecaMa~d4465db0":"agentManagement~case-add~case-edit~caseDetail~client~clientDetail~dashboard~documentManagement~ecaMa~d4465db0","agentManagement~caseDetail~client~clientDetail~documentManagement~ecaManagement~ledger~list~paymentM~6f1d4db4":"agentManagement~caseDetail~client~clientDetail~documentManagement~ecaManagement~ledger~list~paymentM~6f1d4db4","agentManagement~universityManagement":"agentManagement~universityManagement","agentManagement":"agentManagement","universityManagement":"universityManagement","caseDetail~clientDetail~list~paymentManagement":"caseDetail~clientDetail~list~paymentManagement","clientDetail":"clientDetail","caseDetail~client~dashboard~list~paymentManagement~payoutManagement~refundManagement~reports~tatManagement":"caseDetail~client~dashboard~list~paymentManagement~payoutManagement~refundManagement~reports~tatManagement","caseDetail":"caseDetail","list":"list","paymentManagement":"paymentManagement","client":"client","payoutManagement":"payoutManagement","refundManagement":"refundManagement","reports":"reports","tatManagement":"tatManagement","documentManagement":"documentManagement","ecaManagement":"ecaManagement","ledger":"ledger","serviceManagement":"serviceManagement","teamManagement":"teamManagement","viewUniversity":"viewUniversity","case-add":"case-add","case-edit":"case-edit","dashboard":"dashboard","case":"case","clientMainRoute":"clientMainRoute","login":"login","reset-password":"reset-password","reset-password-done":"reset-password-done","reset-password-submit":"reset-password-submit","university":"university"}[chunkId]||chunkId) + "." + {"agentManagement~case-add~case-edit~caseDetail~client~clientDetail~dashboard~documentManagement~ecaMa~d4465db0":"a414aa47","agentManagement~caseDetail~client~clientDetail~documentManagement~ecaManagement~ledger~list~paymentM~6f1d4db4":"95bb57ad","agentManagement~universityManagement":"a92d7e03","agentManagement":"17ec4656","universityManagement":"06ab568f","caseDetail~clientDetail~list~paymentManagement":"a373c81e","clientDetail":"0922eded","caseDetail~client~dashboard~list~paymentManagement~payoutManagement~refundManagement~reports~tatManagement":"15c90167","caseDetail":"7220a430","list":"dfd35b07","paymentManagement":"ce2a9809","client":"a0af249e","payoutManagement":"a297511a","refundManagement":"d64baeca","reports":"5e33654a","tatManagement":"e5cccdb5","documentManagement":"85ca2980","ecaManagement":"82dd90e5","ledger":"4bc3d2d9","serviceManagement":"f5d92462","teamManagement":"6f5dcd96","viewUniversity":"1cc5d428","case-add":"b7541f81","case-edit":"aa30bab9","dashboard":"fc5b906c","case":"c1758520","clientMainRoute":"e3ef0eec","login":"0e6929db","reset-password":"5dcea9d6","reset-password-done":"6fb7f196","reset-password-submit":"9257983b","university":"8fbb7f6e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"agentManagement~case-add~case-edit~caseDetail~client~clientDetail~dashboard~documentManagement~ecaMa~d4465db0":1,"agentManagement~caseDetail~client~clientDetail~documentManagement~ecaManagement~ledger~list~paymentM~6f1d4db4":1,"agentManagement~universityManagement":1,"agentManagement":1,"universityManagement":1,"caseDetail~clientDetail~list~paymentManagement":1,"clientDetail":1,"caseDetail~client~dashboard~list~paymentManagement~payoutManagement~refundManagement~reports~tatManagement":1,"caseDetail":1,"list":1,"paymentManagement":1,"client":1,"payoutManagement":1,"refundManagement":1,"reports":1,"tatManagement":1,"documentManagement":1,"ecaManagement":1,"ledger":1,"serviceManagement":1,"teamManagement":1,"viewUniversity":1,"case-add":1,"case-edit":1,"dashboard":1,"reset-password-submit":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"agentManagement~case-add~case-edit~caseDetail~client~clientDetail~dashboard~documentManagement~ecaMa~d4465db0":"agentManagement~case-add~case-edit~caseDetail~client~clientDetail~dashboard~documentManagement~ecaMa~d4465db0","agentManagement~caseDetail~client~clientDetail~documentManagement~ecaManagement~ledger~list~paymentM~6f1d4db4":"agentManagement~caseDetail~client~clientDetail~documentManagement~ecaManagement~ledger~list~paymentM~6f1d4db4","agentManagement~universityManagement":"agentManagement~universityManagement","agentManagement":"agentManagement","universityManagement":"universityManagement","caseDetail~clientDetail~list~paymentManagement":"caseDetail~clientDetail~list~paymentManagement","clientDetail":"clientDetail","caseDetail~client~dashboard~list~paymentManagement~payoutManagement~refundManagement~reports~tatManagement":"caseDetail~client~dashboard~list~paymentManagement~payoutManagement~refundManagement~reports~tatManagement","caseDetail":"caseDetail","list":"list","paymentManagement":"paymentManagement","client":"client","payoutManagement":"payoutManagement","refundManagement":"refundManagement","reports":"reports","tatManagement":"tatManagement","documentManagement":"documentManagement","ecaManagement":"ecaManagement","ledger":"ledger","serviceManagement":"serviceManagement","teamManagement":"teamManagement","viewUniversity":"viewUniversity","case-add":"case-add","case-edit":"case-edit","dashboard":"dashboard","case":"case","clientMainRoute":"clientMainRoute","login":"login","reset-password":"reset-password","reset-password-done":"reset-password-done","reset-password-submit":"reset-password-submit","university":"university"}[chunkId]||chunkId) + "." + {"agentManagement~case-add~case-edit~caseDetail~client~clientDetail~dashboard~documentManagement~ecaMa~d4465db0":"2cd1c354","agentManagement~caseDetail~client~clientDetail~documentManagement~ecaManagement~ledger~list~paymentM~6f1d4db4":"daca5a6e","agentManagement~universityManagement":"85db40e9","agentManagement":"8c3fb919","universityManagement":"3b25a6a7","caseDetail~clientDetail~list~paymentManagement":"3d6d7242","clientDetail":"5c4c9b05","caseDetail~client~dashboard~list~paymentManagement~payoutManagement~refundManagement~reports~tatManagement":"e342d682","caseDetail":"c5f7ef90","list":"a1bf09d9","paymentManagement":"c5346143","client":"520d5c7a","payoutManagement":"2baa7f43","refundManagement":"9ba5d98b","reports":"93d3152b","tatManagement":"82b6bfa4","documentManagement":"ab623dba","ecaManagement":"e87d4f3e","ledger":"4e2d79da","serviceManagement":"0d6f2cd7","teamManagement":"4743c36e","viewUniversity":"0907e350","case-add":"11dad3f1","case-edit":"8f573ac6","dashboard":"97bf1da7","case":"31d6cfe0","clientMainRoute":"31d6cfe0","login":"31d6cfe0","reset-password":"31d6cfe0","reset-password-done":"31d6cfe0","reset-password-submit":"df9d9a7c","university":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
